import GoogleTranslateWarningModal from './GoogleTranslateWarningModal';

export default GoogleTranslateWarningModal;
